import React from "react";

const Quest = ({ item, onVote, preSelectedChoice }) => {
  const { text } = item;


  const onVoting = (num) => {
    onVote(num, item);
    console.log(num);
  };

  // deployment test
  return (
    <div className="question_main">
      <div className={"question"}>
        <p>{text} </p>
        <div className="choice">
          <button
            className={preSelectedChoice === 5 ? "five chosen" : "five"}
            onClick={() => onVoting(5)}
          >
            True
          </button>
          <button
            className={preSelectedChoice === 4 ? "four chosen" : "four"}
            onClick={() => onVoting(4)}
          >
            Mostly true
          </button>
          <button
            className={preSelectedChoice === 3 ? "three chosen" : "three"}
            onClick={() => onVoting(3)}
          >
            Somewhat true
          </button>
          <button
            className={preSelectedChoice === 2 ? "two chosen" : "two"}
            onClick={() => onVoting(2)}
          >
            Ocasionally true
          </button>
          <button
            className={preSelectedChoice === 1 ? "one chosen" : "one"}
            onClick={() => onVoting(1)}
          >
            Not at all true
          </button>
        </div>
      </div>
    </div>
  );
};

export default Quest;
